import React, { useState, useEffect,useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom"; // 🔑 hooks
import "./GameChoice.css";
import logo from "./assets/logo.png";
import click from "./assets/sounds/click.mp3";
import { usePreferences } from "./hooks/usePreferences";
import Plateau_france from "./assets/Plateau_france.png";
import { useTranslation } from "react-i18next";

export default function GameChoice() {
  const navigate = useNavigate();
  const location = useLocation();
  const profile = location.state?.profile || null; // profil sélectionné
  const [unlockedGames, setUnlockedGames] = useState([]);
  const [unlockCode, setUnlockCode] = useState("");
  const [error, setError] = useState("");
  const token = localStorage.getItem("token") || "";
  const { soundEnabled, timerSoundEnabled } = usePreferences(token);
  const { t, i18n } = useTranslation();

  const API_URL = process.env.REACT_APP_API_URL;

  const timerRef = useRef(null);
  const timerAudioRef = useRef(null); // 🔊 ref pour le son tic-tac

  const fetchUnlockedGames = async () => {
    try {
      const res = await fetch(`${API_URL}/api/game/unlocked`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error(t("errors.fetchGames"));
      const data = await res.json();
      setUnlockedGames(data);
    } catch (err) {
      console.error(err);
      setError(err.message);
    }
  };

  useEffect(() => {
  if (profile?.preferredLanguage) {
    i18n.changeLanguage(profile.preferredLanguage.toLowerCase());
  }
}, [profile, i18n]);

  useEffect(() => {
    if (token) fetchUnlockedGames();
  }, [token]);

  const handleUnlock = async () => {
    if (!unlockCode.trim()) return setError(t("errors.invalidCode"));

    try {
      const res = await fetch(`${API_URL}/api/game/unlock`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ code: unlockCode.trim() }),
      });

      if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.message || t("errors.invalidCodeUsed"));
      }

      const data = await res.json(); // { game }
      setUnlockedGames((prev) => [...prev, data.game]);
      setUnlockCode("");
      setError("");
    } catch (err) {
      console.error(err);
      setError(err.message);
    }
  };

  const isUnlocked = (gameName) =>
    unlockedGames.some((g) => g.name.toLowerCase() === gameName.toLowerCase());

  const handleSelectGame = (gameName) => {
    if (!isUnlocked(gameName)) return;
    i18n.changeLanguage(profile.preferredLanguage);
    navigate("/menu", { state: { token, profile, game: gameName} });
  };

    const playSound = (sound, isTimer = false) => {
    if ((isTimer && !timerSoundEnabled) || (!isTimer && !soundEnabled)) return;

    if (isTimer) {
      // stoppe un éventuel son déjà lancé
      if (timerAudioRef.current) {
        timerAudioRef.current.pause();
        timerAudioRef.current.currentTime = 0;
      }
      timerAudioRef.current = new Audio(sound);
      timerAudioRef.current.loop = true; // tic-tac en continu
      timerAudioRef.current.play();
    } else {
      const audio = new Audio(sound);
      audio.play();
    }
  };


  return (
    <div className="gamechoice-container">
      <img src={logo} alt="VinOdys’sait" className="logo_3" />
      <h1>{t("gameChoice.title")}</h1>

      {error && <p className="error-msg">{error}</p>}

      <div className="gamechoice-grid">
       <div
  className={`game-card ${isUnlocked("france") ? "france-unlocked" : "locked"}`}
  onClick={() => { playSound(click); handleSelectGame("france"); }}
>
          <img src={Plateau_france} alt="Plateau_france" className="Plateau_France" />
          <h2>{isUnlocked("france") ? t("gameChoice.france") : t("gameChoice.franceLocked")}</h2>
        </div>
      </div>

      {/* 🔒 Le bouton de déverrouillage n’apparaît que si “France” est verrouillée */}
{!isUnlocked("france") && (
  <div className="unlock-section">
    <input
      type="text"
      placeholder={t("gameChoice.unlockPlaceholder")}
      value={unlockCode}
      onChange={(e) => setUnlockCode(e.target.value)}
    />
    <button className="bg-Purple-600" onClick={() => { playSound(click); handleUnlock(); }}>
     {t("gameChoice.unlockButton")}
    </button>
  </div>
)}

      <button className="back-btn" onClick={() => {playSound(click);navigate(-1)}}>
        ←
      </button>
    </div>
  );
}
